/* eslint-disable quotes */
import React from 'react';
import { Button, Modal, RadioButton } from '../../atoms';
import { ICancelTopUpModal } from './types';
import { InsuranceImg, QuotesImg } from '../../../topup-src/assets/img';
import {
    StyledContainer,
    StyledContainerWrapper,
    StyledContainerUL,
    StyledBtnContainerWrapper,
    StyledFeatureWrapper,
    StyledRowAlignment,
    StyledBtnWrapper,
    StyledChatSpan
} from './styles';
import { SEGMENT_ACTIONS } from '../../../utils/constants/SegmentActionConstants';
import useSegment from '../../../utils/hooks/useSegment';
import { getSegmentPageName } from '../../../utils/common';
import { useLocation } from 'react-router-dom';
import { TextView } from '../../../topup-src/components/atoms/TextView';
import theme from '../../../theme';
import { ImageView } from '../../atoms/ImageView';
import { FEEDBACK_CONSTANTS } from '../../../utils/constants/FeedbackConstants';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxState } from '../../../redux';
import { setUnSelectTopupFeedback } from '../../../redux/slices/ApplicationStateSlice';
import { openFreshChat } from '../../../topup-src/utils/Freshchat';
import { handleChatCTAClickUtil, handleSelectTopUpUtil, handleUnSelectTopUpUtil, saveTopUpFeedbackUtil } from './utils';

const CancelTopUpModal: React.FunctionComponent<ICancelTopUpModal> = ({
    isVisible,
    setIsVisible,
    showSummary,
    selectedSI,
    pageTitle
}) => {
    const trackClick = useSegment('click');
    const location = useLocation();
    const dispatch = useDispatch();
    const [feedback, setFeedback] = React.useState('');
    const currentPageAction = SEGMENT_ACTIONS.PAGE[getSegmentPageName(location.pathname) as any];
    const userId = useSelector((state: ReduxState) => state.user.userData.data?.userId || '');

    const handleSelectTopUp = () => {
        handleSelectTopUpUtil(trackClick, currentPageAction, selectedSI, pageTitle);
        setIsVisible(!isVisible);
    };

    const handleUnSelectTopUp = () => {
        saveTopUpFeedbackUtil(feedback, userId);
        dispatch(setUnSelectTopupFeedback({ unSelectTopupFeedback: feedback }));
        handleUnSelectTopUpUtil(trackClick, currentPageAction, selectedSI, pageTitle, feedback);
        showSummary(false);
    };

    const handleChatCTAClick = () => {
        openFreshChat();
        handleChatCTAClickUtil(trackClick, currentPageAction);
    };

    return (
        <Modal title={''} subTitle={''} isVisible={isVisible} setIsVisible={setIsVisible}>
            <StyledContainer>
                <StyledContainerWrapper>
                    <TextView fontSize="24px" margin="10px 0px 0px 0px" color={theme.colors.loopEmerald}>
                        You are proceeding without extra health cover...
                    </TextView>
                </StyledContainerWrapper>
                <StyledFeatureWrapper>
                    <StyledContainerUL>
                        <ImageView
                            src={QuotesImg}
                            backgroundColor={theme.colors.planRed}
                            height="26px"
                            width="26px"
                            containerMinHeight="42px"
                            containerWidth="42px"
                            radius="21px"
                        />
                        <TextView fontSize="14px" margin="0px 0px 0px 12px" color={theme.colors.loopEmerald}>
                            The most cost-effective way <br />
                            to get more coverage
                        </TextView>
                    </StyledContainerUL>
                    <StyledContainerUL>
                        <ImageView
                            src={InsuranceImg}
                            backgroundColor={theme.colors.coverYellow}
                            height="26px"
                            width="26px"
                            containerMinHeight="42px"
                            containerWidth="42px"
                            radius="21px"
                        />
                        <TextView fontSize="14px" color={theme.colors.loopEmerald} margin="0px 0px 0px 12px">
                            Loop guarantees best-in-class
                            <br />
                            benefits
                        </TextView>
                    </StyledContainerUL>
                </StyledFeatureWrapper>
                <StyledContainerWrapper>
                    <TextView fontSize="14px" color={theme.colors.beyondGrey} margin="20px 0px 20px 10px">
                        <b>Still don’t want a top up?</b> Please tell us why
                    </TextView>
                    <StyledRowAlignment>
                        {FEEDBACK_CONSTANTS.map((options, index) => {
                            return (
                                <RadioButton
                                    key={index}
                                    id={options}
                                    name={options}
                                    selectedId={feedback}
                                    onClick={() => setFeedback(options)}
                                    disabled={false}
                                />
                            );
                        })}
                    </StyledRowAlignment>
                </StyledContainerWrapper>
                <StyledBtnContainerWrapper>
                    <StyledBtnWrapper>
                        <Button
                            type="primary"
                            disabled={feedback.length ? false : true}
                            onClick={handleUnSelectTopUp}
                            fullWidth={true}
                        >
                            Yes, I don’t want a top up
                        </Button>
                    </StyledBtnWrapper>
                    <StyledBtnWrapper>
                        <Button type="secondary" onClick={handleSelectTopUp} fullWidth={true}>
                            Go back to select a top up
                        </Button>
                    </StyledBtnWrapper>
                </StyledBtnContainerWrapper>
                <StyledBtnContainerWrapper>
                    <TextView fontSize="16px" color={theme.colors.beyondGrey}>
                        {'Got a question?  '}
                        <StyledChatSpan onClick={() => handleChatCTAClick()}>
                            <TextView fontWeight="600" fontSize="16px" color={theme.colors.loopEmerald}>
                                Talk to an expert →
                            </TextView>
                        </StyledChatSpan>
                    </TextView>
                </StyledBtnContainerWrapper>
            </StyledContainer>
        </Modal>
    );
};

export default CancelTopUpModal;
